import Form from 'antd/es/form';
import Input from 'antd/es/input';
import React from 'react';

import type { FileBlockConfig, PipelineBlock } from '@mai/types';

interface FileBlockEditorProps {
  block: PipelineBlock & { type: 'file' };
  onConfigChange: (config: FileBlockConfig) => void;
}

export const FileBlockEditor: React.FC<FileBlockEditorProps> = ({
  block,
  onConfigChange,
}) => {
  const [form] = Form.useForm<FileBlockConfig>();

  const initialConfig = block.config as FileBlockConfig;

  const handleValuesChange = (
    _: unknown,
    allValues: Partial<FileBlockConfig>,
  ) => {
    onConfigChange({
      ...block.config,
      ...allValues,
    });
  };

  return (
    <Form
      form={form}
      layout="vertical"
      size="small"
      onValuesChange={handleValuesChange}
    >
      <Form.Item
        label="File ID"
        name="file_id"
        required
        help="21-character file identifier"
        rules={[
          { required: true, message: 'File ID is required' },
          { len: 21, message: 'File ID must be exactly 21 characters' },
        ]}
        initialValue={initialConfig.file_id}
      >
        <Input placeholder="Enter file ID" maxLength={21} />
      </Form.Item>
    </Form>
  );
};
